import { Checkbox } from 'react-bootstrap';
import { IOpoContactPosition } from '@nkr/models/opo-contact';

export const otherPositionId = 0;

interface IProps {
    positions: IOpoContactPosition[],
    value: number[],
    onChange: (value: number[]) => void
}

const ContactRoleCheckboxes = ({ positions, value, onChange }: IProps) => {
    const sortedPositions = [...positions].sort((a, b) => Number(a.id == otherPositionId) - Number(b.id == otherPositionId) || a.description.localeCompare(b.description));

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '4px 16px' }}>
            {sortedPositions.map(position =>
                <Checkbox
                    key={position.id}
                    checked={value.indexOf(position.id) >= 0}
                    onChange={(e: any) => onChange(e.target.checked ? [...value, position.id] : value.filter(x => x != position.id))}
                    style={{ margin: 0 }}>
                    {position.description}
                </Checkbox>
            )}
        </div>
    );
}

export default ContactRoleCheckboxes;
